export default {
  emailHost: {
    value: '',
    required: true,
    state: null
  },
  emailPort: {
    value: '',
    required: true,
    state: null
  },
  emailFrom: {
    value: '',
    required: true,
    state: null
  },
  replyTo: {
    value: '',
    required: true,
    state: null
  },
  envioAutenticado: {
    value: false,
    required: false,
    state: null
  },
  emailUser: {
    value: null,
    required: false,
    state: null
  },
  emailPassword: {
    value: null,
    required: false,
    state: null
  },
  safeConnection: {
    value: null,
    options: [
      { value: 1, text: 'NENHUMA' },
      { value: 2, text: 'SSL' },
      { value: 3, text: 'STARTTLS' }
    ],
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/email/components/add/emailenvioadd-form.js